import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// icon user
import { FaUser } from "react-icons/fa";
import { userEvent } from "../controller";
import teams from "../assets/data/team";
import Loading from "../components/Loading";
import { mission } from "../controller";
import Noti from "../components/Noti";
import Pagination from "../components/Pagination/Pagination";
import HHH from "../assets/images/lienminhhhh.png";
import Aurora from "../assets/images/lienminhhhd.png";
import FMCG from "../assets/images/groupfmcg.png";
import VHE from "../assets/images/groupvhe.png";
import hhhteam from "../assets/images/hhhteam.png";
import hhoteam from "../assets/images/hhoteam.png";
import fmcgteam from "../assets/images/fmcgteam.png";
import vheteam from "../assets/images/vheteam.png";

const initialTasks = [
  {
    id: "1",
    title: "Nhiệm vụ 01: +20 điểm",
    description: (
      <>
        <b>
          Tự quay và đăng tải một video clip review chân thực, hấp dẫn về sản
          phẩm hoặc dịch vụ của Ngôi nhà Hùng Hậu.
        </b>
        <br />
        Độ dài clip: 1-3 phút
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Chất lượng video: Hình ảnh rõ nét, ánh sáng tốt, âm thanh rõ ràng.
          </li>
          <li>
            Chủ thể nội dung video là trải nghiệm chân thực về sản phẩm/ dịch vụ
            của Ngôi nhà Hùng Hậu (Sản phẩm FMCG, khóa học, lớp học tại VHE...)
          </li>
          <li>
            Đăng trên các kênh truyền thông MXH của bạn (ví dụ: YouTube,
            Facebook, Instagram Reels, TikTok).
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "2",
    title: "Nhiệm vụ 02: +10 điểm",
    description: (
      <>
        <b>
          Đăng tải bài viết review kèm hình ảnh về sản phẩm/ dịch vụ của Ngôi
          nhà Hùng Hậu.
        </b>
        <br />
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>Chất lượng: Hình ảnh chất lượng, rõ nét</li>
          <li>
            Yêu cầu: Hình ảnh tự chụp, tự thiết kế, tự vẽ, sáng tạo...liên quan
            đến các sản phẩm/ dịch vụ của Ngôi nhà Hùng Hậu (Sản phẩm FMCG, khóa
            học, lớp học tại VHE...). Không sử dụng hình ảnh có sẵn từ internet.
          </li>
          <li>
            Đăng trên các kênh truyền thông MXH của bạn (ví dụ: Facebook,
            Instagram Reels, TikTok...).
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "3",
    title: "Nhiệm vụ 03: +5 điểm",
    description: (
      <>
        <b>
          Đăng tải hình ảnh chụp cá nhân hoặc tập thể tại các sự kiện hoặc cơ sở
          của Ngôi nhà Hùng Hậu.
        </b>
        <br />
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Hình ảnh cá nhân/tập thể rõ nét, phù hợp với tiêu chí của chương
            trình.
          </li>
          <li>
            Đăng trên các kênh truyền thông MXH của bạn (ví dụ: Facebook,
            Instagram Reels, TikTok...).
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
  {
    id: "4",
    title: "Nhiệm vụ 04: +1 điểm",
    description: (
      <>
        <b>
          Chia sẻ công khai các bài đăng từ các trang mạng xã hội chính thức của
          các Group/ ĐVTV thuộc Ngôi nhà Hùng Hậu.
        </b>
        <br />
        <ul className="list-disc ml-5 mt-2 mb-2 text-base">
          <li>
            Đảm bảo bài đăng được chia sẻ ở chế độ công khai trên các tài khoản
            MXH cá nhân, nhóm, hoặc trang cộng đồng
          </li>
          <li>
            Bài đăng đi kèm hashtag:{" "}
            <b>#HungHau #HHH #Trustyourchoices #NgayTruyenthongHungHau</b>
          </li>
          <li>
            <b>Lưu ý: Bài đăng hợp lệ tính từ ngày 20/06/2025</b>
          </li>
        </ul>
      </>
    ),
    completed: false,
    resultLink: "",
    input: "",
  },
];

export default function TeamPage() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(initialTasks);
  const [openTask, setOpenTask] = useState(tasks[0].id);
  const [isLoading, setIsLoading] = useState(true);
  const [info, setInfo] = useState({});
  const [submitStatus, setSubmitStatus] = useState(false);
  const [submissions, setSubmissions] = useState([]);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  // Pagination state for submissions
  const [submissionPagination, setSubmissionPagination] = useState({
    page: 1,
    limit: 10,
    totalCount: 0,
    totalPages: 0,
  });

  useEffect(() => {
    // scroll to top when component mounts
    window.scrollTo(0, 0);

    // Hàm kiểm tra thời gian đóng/mở
    const checkCloseTime = () => {
      const now = new Date();
      // Đóng từ 23:59:00 ngày 26/6/2025
      const closeTime = new Date(2025, 5, 26, 23, 59, 0, 0); // Tháng 6 là 5 (JS month 0-based)
      if (now >= closeTime) {
        setIsClosed(true);
      } else {
        setIsClosed(false);
      }
    };

    checkCloseTime(); // Kiểm tra ngay khi vào trang

    // Thiết lập interval kiểm tra mỗi phút
    const interval = setInterval(checkCloseTime, 20 * 1000);

    return () => clearInterval(interval);
  }, []);

  const fetchSubmissions = async (page = 1, limit = 2) => {
    try {
      setSubmissionLoading(true);
      const response = await mission.getSubmissionById({
        userEventId: info.id,
        page: page,
        limit: limit,
      });

      if (response) {
        setSubmissions(
          response.submissions?.rows || response.submissions || []
        );
        const totalCount = response.totalCount || 0;
        const totalPages = Math.ceil(totalCount / limit);

        setSubmissionPagination({
          page: page,
          limit: limit,
          totalCount: totalCount,
          totalPages: totalPages,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmissionLoading(false);
    }
  };

  const fetchUserEvent = async () => {
    try {
      setIsLoading(true);
      const response = await userEvent.getUserEvent({
        mail: sessionStorage.getItem("mail"),
      });
      if (response) {
        // console.log("User events fetched successfully:", response);
        const teamName =
          teams.find((team) => team.key === response?.userEvent?.team)?.name ||
          "Unknown Team";
        const captain = teams.find(
          (team) => team.key === response?.userEvent?.team
        )?.captain;
        setInfo({
          name: response?.user365?.displayName || "User",
          mail: response?.user365?.mail || "",
          photo: response?.user365?.photo || "",
          teamKey: response?.userEvent?.team || "",
          teamName: teamName,
          teamSlogan:
            teams.find((team) => team.key === response?.userEvent?.team)
              ?.slogan || "Team Slogan",
          captainName: captain,
          totalScore: response?.result?.score + response?.result?.fbScore || 0,
          mission1Score: response?.result?.mission1Score || 0,
          mission2Score: response?.result?.mission2Score || 0,
          mission3Score: response?.result?.mission3Score || 0,
          mission4Score: response?.result?.mission4Score || 0,
          fbScore: response?.result?.fbScore || 0,
          id: response?.userEvent?.id || "",
        });
      }
    } catch (error) {
      console.error("Error fetching user events:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserEvent();
  }, []);

  useEffect(() => {
    if (!info.id) return;
    fetchSubmissions(submissionPagination.page, submissionPagination.limit);
  }, [info.id]);

  // Handle pagination change
  const handleSubmissionPageChange = (newPage) => {
    setSubmissionPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
    fetchSubmissions(newPage, submissionPagination.limit);
  };

  const handleInputChange = (id, value) => {
    setTasks((tasks) =>
      tasks.map((task) => (task.id === id ? { ...task, input: value } : task))
    );
  };

  const handleSubmit = async (id) => {
    if (isClosed) {
      alert("Đã hết thời gian nộp bài. Hệ thống đã đóng nhận bài thi!");
      return;
    }
    try {
      const result = await mission.createSubmission({
        userEventId: info.id,
        mission: Number(id),
        link: tasks.find((task) => task.id === id).input,
      });
      if (result.message === "Submission created successfully") {
        setSubmitStatus(true);
        setTasks((tasks) =>
          tasks.map((task) => (task.id === id ? { ...task, input: "" } : task))
        );
        // Refresh submissions after successful submit and reset to first page
        setSubmissionPagination((prev) => ({ ...prev, page: 1 }));
        fetchSubmissions(1, submissionPagination.limit);
      } else {
        throw new Error(result.message || "Failed to submit task");
      }
    } catch (error) {
      console.error("Error submitting task:", error);
      alert("Đã có lỗi xảy ra khi gửi kết quả nhiệm vụ. Vui lòng thử lại sau.");
    }
  };

  const getMissionName = (mission) => {
    return `Nhiệm vụ ${mission}`;
  };

  const getStatusText = (status) => {
    switch (status) {
      case "approved":
        return "Đã duyệt";
      case "pending":
        return "Chờ duyệt";
      case "rejected":
        return "Từ chối";
      default:
        return status;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "approved":
        return "text-green-600 bg-green-100";
      case "pending":
        return "text-yellow-600 bg-yellow-100";
      case "rejected":
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  const getPoints = (mission, status) => {
    if (status !== "approved") return 0;
    const pointsMap = {
      1: 10,
      2: 20,
      3: 5,
      4: 10,
    };
    return pointsMap[mission] || 0;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0253e1] to-[#25c8ff] p-6 font-montserrat">
      {isClosed && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">
              ĐÃ ĐÓNG NHẬN BÀI
            </h2>
            <p className="text-lg text-gray-700">
              Đã hết thời gian nộp bài. Hệ thống đã đóng nhận bài thi lúc 23:59
              hôm nay.
              <br />
              Xin cảm ơn bạn đã tham gia!
            </p>
          </div>
        </div>
      )}
      {submitStatus && (
        <Noti
          message={<span>Đã gửi kết quả nhiệm vụ thành công!</span>}
          onClose={() => setSubmitStatus(false)}
        ></Noti>
      )}
      {isLoading ? (
        <Loading></Loading>
      ) : (
        <>
          <div className="w-11/12 mx-auto flex justify-between items-center">
            <button className="border  border-[#14FFFF] bg-gradient-to-r from-[#001FBA] to-[#052FFF] text-white rounded-md px-6 max-md:px-2 py-2 font-semibold hover:bg-white hover:text-[#0253e1] transition">
              <a href="/user/events" className="max-md:text-xs leading-none">
                QUAY LẠI TRANG CHỦ
              </a>
            </button>
            <div className="flex items-center gap-2 text-white text-base">
              <span>{sessionStorage.getItem("mail")}</span>
              <span className="text-xl">
                <FaUser />
              </span>
            </div>
          </div>

          {/* Club Info */}
          <div className="w-11/12 mx-auto gap-12 mt-12 grid grid-cols-5 max-md:grid-cols-1 items-center rounded-3xl px-6 py-10 shadow-lg">
            <img
              src={
                info?.teamKey === "Đội Harmony"
                  ? HHH
                  : info?.teamKey === "Đội Heart"
                  ? VHE
                  : info?.teamKey === "Đội House"
                  ? FMCG
                  : Aurora
              }
              alt="Club Card"
              className="rounded-2xl drop-shadow-xl object-cover max-h-[600px] col-span-2 max-md:col-span-3 max-md:w-full"
              style={{ objectPosition: "center" }}
              loading="lazy"
            />
            <div className="text-white mt-4 col-span-3">
              {/* <h1 className="text-9xl leading-[1] font-bold bg-gradient-to-r border-stone-50 border-[#FF7E22] from-[#FFD942] to-[#FF7E22] text-transparent bg-clip-text drop-shadow-sm text-center">
                {info?.teamName}
              </h1> */}
              {/* <img
                src={
                  info?.teamKey === "Đội Harmony"
                    ? HHH
                    : info?.teamKey === "Đội Heart"
                    ? VHE
                    : info?.teamKey === "Đội House"
                    ? FMCG
                    : Aurora
                }
                alt="Club Card"
                className=" max-w-[400px] max-md:w-full mx-auto rounded-2xl drop-shadow-xl object-cover col-span-2"
                style={{ objectPosition: "center" }}
                loading="lazy"
              /> */}
              <h1 className="text-6xl max-md:text-3xl font-bold leading-normal text-center bg-gradient-to-r from-[#FFD942] to-[#FF7E22] text-transparent bg-clip-text">
                {info?.teamKey}
              </h1>

              <div className="mt-4 text-xl space-y-2">
                <div>
                  <b>Slogan:</b> {info?.teamSlogan}
                </div>
                <div>
                  <b>Đội trưởng:</b> {info?.captainName}
                </div>
                <div className="w-full border-b border-gray-400"></div>
                <div>
                  <b>Tên người chơi:</b> {info?.name}
                </div>
                <div>
                  <b>TỔNG ĐIỂM NHIỆM VỤ:</b> {info?.totalScore}
                </div>
                <div className="flex text-base items-center w-full gap-4 flex-wrap">
                  <div>
                    <span> Nhiệm vụ 1:</span> {info?.mission1Score}
                  </div>
                  <div>
                    <span> Nhiệm vụ 2:</span> {info?.mission2Score}
                  </div>
                  <div>
                    <span> Nhiệm vụ 3:</span> {info?.mission3Score}
                  </div>
                  <div>
                    <span> Nhiệm vụ 4:</span> {info?.fbScore}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mission Board */}
          <div className="bg-white/20 w-11/12 mx-auto mt-14 rounded-3xl px-12 py-10 max-md:px-6 shadow-lg">
            <h2 className="text-6xl max-md:text-3xl font-bold leading-normal text-center bg-gradient-to-r  from-[#FFD942] to-[#FF7E22] text-transparent bg-clip-text drop-shadow-sm mb-10">
              BẢNG NHIỆM VỤ
            </h2>
            <div className="flex flex-col gap-5">
              {tasks.map((task, idx) => (
                <div key={task.id} className="w-full">
                  <button
                    className={`w-full flex justify-between items-center px-4 py-3 rounded-t-xl font-bold text-lg ${
                      openTask === task.id
                        ? "bg-gradient-to-b from-[#0755FE] to-[#043398] text-white"
                        : "bg-gradient-to-b from-[#0755FE] to-[#043398] text-white rounded-xl"
                    }`}
                    onClick={() =>
                      setOpenTask(openTask === task.id ? null : task.id)
                    }
                  >
                    <span className="">{task.title}</span>
                    <span>{openTask === task.id ? "▲" : "▼"}</span>
                  </button>
                  {openTask === task.id && (
                    <div className="bg-[#0948E94D]/30 rounded-b-xl px-4 py-5 text-base text-white">
                      <div className="pb-4">{task.description}</div>
                      {!task.completed ? (
                        <>
                          <div className="flex gap-2 max-md:flex-col">
                            <input
                              type="text"
                              className="flex-1 px-3 py-2 text-black text-lg rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-[#0253e1]"
                              placeholder="Link nhập kết quả nhiệm vụ"
                              value={task.input}
                              onChange={(e) =>
                                handleInputChange(task.id, e.target.value)
                              }
                              disabled={isClosed}
                            />
                            <button
                              className="bg-gradient-to-r from-[#ffc400] to-[#ff8800] text-white hover:cursor-pointer font-bold px-5 py-2 rounded-md hover:opacity-90 transition"
                              onClick={() => handleSubmit(task.id)}
                              disabled={!task.input || isClosed}
                            >
                              GỬI KẾT QUẢ
                            </button>
                          </div>
                          {isClosed && (
                            <div className="text-red-500 mt-3 text-lg text-center font-bold">
                              Đã hết thời gian nộp bài. Hệ thống đã đóng nhận
                              bài thi!
                            </div>
                          )}
                          {/* <div className="text-white mt-3 text-lg text-center">
                            Bạn đã hoàn thành gửi kết quả nhiệm vụ, hãy sáng tạo
                            và cùng đồng đội hoàn thành các nhiệm bên dưới nhé{" "}
                          </div> */}
                        </>
                      ) : (
                        <div className="font-semibold text-green-600 mt-2">
                          Đã gửi kết quả:{" "}
                          <a
                            href={task.resultLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline break-all"
                          >
                            {task.resultLink}
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Submissions Table */}
          {/* <div className="bg-white/20 w-11/12 mx-auto mt-14 rounded-3xl px-6 py-10 shadow-lg">
            <h2 className="text-3xl font-bold text-center text-[#ffc400] drop-shadow-sm mb-4">
              LỊCH SỬ NỘP BÀI
            </h2>


            {submissionPagination.totalCount > 0 && (
              <div className="text-center text-white mb-4">
                Tổng cộng: {submissionPagination.totalCount} bài nộp
              </div>
            )}

            {submissionLoading ? (
              <div className="text-center text-white text-lg py-8">
                Đang tải danh sách bài nộp...
              </div>
            ) : submissions && submissions.length > 0 ? (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full bg-white rounded-lg overflow-hidden">
                    <thead className="bg-gradient-to-r from-[#0253e1] to-[#25c8ff]">
                      <tr>
                        <th className="px-4 py-3 text-left text-white font-bold">
                          Nhiệm vụ
                        </th>
                        <th className="px-4 py-3 text-left text-white font-bold">
                          Link
                        </th>
                        <th className="px-4 py-3 text-center text-white font-bold">
                          Ngày nộp
                        </th>
                        <th className="px-4 py-3 text-center text-white font-bold">
                          Trạng thái
                        </th>
                        <th className="px-4 py-3 text-center text-white font-bold">
                          Điểm
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {submissions.map((submission, index) => (
                        <tr
                          key={submission.id}
                          className={
                            index % 2 === 0 ? "bg-gray-50" : "bg-white"
                          }
                        >
                          <td className="px-4 py-3 text-gray-800 font-medium">
                            {getMissionName(submission.mission)}
                          </td>
                          <td className="px-4 py-3">
                            <a
                              href={submission.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 hover:text-blue-800 underline break-all text-sm"
                            >
                              {submission.link}
                            </a>
                          </td>
                          <td className="px-4 py-3 text-center">
                            {formatDate(submission.createdAt)}
                          </td>
                          <td className="px-4 py-3 text-center">
                            <span
                              className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                submission.status
                              )}`}
                            >
                              {getStatusText(submission.status)}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800">
                            {getPoints(submission.mission, submission.status)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {submissionPagination.totalPages > 1 && (
                  <div className="mt-6 flex justify-center">
                    <Pagination
                      currentPage={submissionPagination.page}
                      totalPages={submissionPagination.totalPages}
                      onPageChange={handleSubmissionPageChange}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="text-center text-white text-lg">
                Chưa có bài nộp nào
              </div>
            )}
          </div> */}
        </>
      )}
    </div>
  );
}
